import React, { useState } from "react";
import { Box } from "@mui/material";
import "../../assets/settings.scss";
import { useNavigate } from "react-router-dom";
import {
  callAPIInterface,
  updateUserAndWalletAccountSession,
} from "../constants";
import Button from "../button/Button";
import {
  accountCloserInProcess,
  accountCloserInProcessSubMsg,
  accountRetainMsg,
  closeAccount,
  revokeRequest,
} from "../messages";
import { timerIcon } from "../images";
import Text from "../text/Text";
import CustomDivider from "../divider/Divider";
import CommonHeader from "../CommonHeader";

function RequestInProcess() {
  const navigate = useNavigate();
  const [buttonLoader, setButtonLoader] = useState(false);

  const handleRevoke = () => {
    setButtonLoader(true);
    callAPIInterface("POST", "/close-account/revoke")
      .then(() => {
        setButtonLoader(false);
        updateUserAndWalletAccountSession();
        navigate("/settings/advance-settings/close-account/request-accepted");
      })
      .catch((_err) => {
        setButtonLoader(false);
      });
  };

  return (
    <>
      <CommonHeader textAfterIcon={closeAccount} icon="backArrow" />
      <Box className="options-container">
        <Box className="request-in-process-wrapper">
          <Box className="module-container">
            <Box
              display="flex"
              minHeight="395px"
              flexDirection="column"
              justifyContent="space-between"
            >
              <Box textAlign="center">
                <img
                  src={timerIcon}
                  height="54px"
                  width="54px"
                  style={{ marginBottom: "16px" }}
                />
                <Text className="default-text" size={22} font="bold">
                  {accountCloserInProcess}
                </Text>
                <Text className="grey-text" size={16} font="regular">
                  {accountCloserInProcessSubMsg}
                </Text>
              </Box>
              <Text className="default-text" size={16} font="regular">
                {accountRetainMsg}
              </Text>
            </Box>
            <Box>
              <CustomDivider className="settings-divider" />
              <Button
                fullWidth
                variant="contained"
                className="settings-button"
                label={revokeRequest}
                onClick={handleRevoke}
                disabled={buttonLoader}
                loading={buttonLoader}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default RequestInProcess;
